var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"announcement"},[_c('base-list-management',{ref:"tableRef",attrs:{"configData":_setup.configData},on:{"update:configData":function($event){_setup.configData=$event},"update:config-data":function($event){_setup.configData=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }